export { default as IndexCarousel } from './IndexCarousel';



// WEBPACK FOOTER //
// ./src/components/IndexCarousel/index.ts